import { render, staticRenderFns } from "./CreaQuestionario.vue?vue&type=template&id=e86c7084&"
import script from "./CreaQuestionario.vue?vue&type=script&lang=js&"
export * from "./CreaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports